import Store from './store'
require('./menuModule')
require('./styleWatch')
export default Store;